import { render, staticRenderFns } from "./VerticalLocker.vue?vue&type=template&id=83503b16&scoped=true&"
var script = {}
import style0 from "./VerticalLocker.vue?vue&type=style&index=0&id=83503b16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83503b16",
  null
  
)

export default component.exports